<app-scorm-bus></app-scorm-bus>

<router-outlet *ngIf="windowReady"></router-outlet>